import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next/';

import { Modal } from '@components/containers';
import { LoginFormWrapper } from '@components/forms';
import FacebookLoginButton from '@components/ui/FacebookLoginButton/FacebookLoginButton';
import GoogleLoginButton from '@components/ui/GoogleLoginButton/GoogleLoginButton';
import TextLink from '@components/ui/TextLink/TextLink';

import styles from './LoginModal.module.scss';
import Props from './LoginModal.props';

const LoginModal = ({ onRegisterClick, className, onClose, ...modalProps }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal {...modalProps} onClose={onClose} className={cn(styles.LoginModal, className)}>
      <div className={styles.Header}>
        <h2 className="mb-xs">{t('DOMAIN.AUTHENTICATION.LOGIN')}</h2>
      </div>
      <LoginFormWrapper shouldRedirect={false} onLogin={onClose} />
      <div className={styles.SocialLogins}>
        <FacebookLoginButton className={styles.FacebookLogin} />
        <GoogleLoginButton className={styles.GoogleLogin} />
      </div>
      <p className="mt-md">
        {t('DOMAIN.AUTHENTICATION.REGISTER_CTA.QUESTION')}{' '}
        <TextLink noIndex onClick={onRegisterClick}>
          {t('DOMAIN.AUTHENTICATION.REGISTER_CTA.LINK')}
        </TextLink>
      </p>
    </Modal>
  );
};

export default LoginModal;
